import { render } from "./ContentArea.vue?vue&type=template&id=27a201b2&scoped=true&ts=true"
import script from "./ContentArea.vue?vue&type=script&lang=ts"
export * from "./ContentArea.vue?vue&type=script&lang=ts"

import "./ContentArea.vue?vue&type=style&index=0&id=27a201b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a201b2"]])

export default __exports__